import { toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "item-title"
};
var _hoisted_2 = {
  class: "title-div"
};
import { ChevronRightDoubleIcon, HelpCircleIcon } from 'tdesign-icons-vue-next';
export default {
  __name: 'itemTitle',
  props: {
    title: {
      type: String,
      default: ''
    },
    tip: {
      type: String,
      default: ''
    }
  },
  emits: ['changeTab'],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var props = __props;
    var emit = __emit;

    /** 事件相关 */
    // 查看更多
    var viewMore = function viewMore() {
      emit('changeTab');
    };
    return function (_ctx, _cache) {
      var _component_t_tooltip = _resolveComponent("t-tooltip");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createTextVNode(_toDisplayString(__props.title) + " ", 1), _createVNode(_component_t_tooltip, {
        class: "placement top center",
        content: __props.tip,
        placement: "top",
        "overlay-style": {
          width: '260px'
        },
        "show-arrow": ""
      }, {
        default: _withCtx(function () {
          return [_createVNode(_unref(HelpCircleIcon), {
            class: "circle-icon"
          })];
        }),
        _: 1
      }, 8, ["content"])]), _createElementVNode("div", {
        class: "more-div",
        onClick: viewMore
      }, [_cache[0] || (_cache[0] = _createTextVNode(" 查看更多 ", -1)), _createVNode(_unref(ChevronRightDoubleIcon), {
        class: "right-icon"
      })])]);
    };
  }
};